<script>
import TwButton from '@/components/generic/tw-button.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import FundraiserTopHeader from '@/components/fundraisers/public/fundraiser-top-header.vue'
import FundraiserTeamRightColumn from '@/components/fundraisers/public/teams/fundraiser-team-right-column.vue'
import FundraiserTeamLeftColumn from '@/components/fundraisers/public/teams/fundraiser-team-left-column.vue'
import { useTeamPublicStore } from '@/stores/teamPublic.js'
import { UserGroupIcon } from '@heroicons/vue/24/outline'
export default {
  name: 'FundraiserTeamLayoutModern',
  components: { FundraiserTeamLeftColumn, FundraiserTeamRightColumn, FundraiserTopHeader, TwContainer, TwButton, UserGroupIcon },
  mixins:[fundraiserPublicFetchMixin, loggedInUserMixin],
  props: {
    teamId: {
      type: Number,
      required: true
    }
  },
  computed: {
    team() {
      return useTeamPublicStore().getItemById(this.teamId)
    }
  },
  mounted() {
    useTeamPublicStore().fetchItemById(this.teamId)
  }
}
</script>

<template>
  <div v-if="fundraiser && team && (fundraiser.published || (loggedInUser && loggedInUser.id === fundraiser.owner_user_id))">
    <fundraiser-top-header :fundraiser="fundraiser" class="py-4" />
    <div v-if="fundraiser.cover_image_url" class="bg-cover bg-no-repeat bg-center bg-overlay md:min-h-60 lg:min-h-96 flex items-center" :style="`background-image: url('${fundraiser.cover_image_url}');`">
      <tw-container class="pt-7 pb-8 lg:py-20 max-w-[1360px]">
        <div class="grid lg:grid-cols-3 gap-8 overflow-hidden items-center">
          <div class="flex flex-col gap-3 lg:gap-4 col-span-2 text-white text-center sm:text-left py-5">
            <h5 class="text-base lg:text-lg xl:text-xl">
             <!-- <UserGroupIcon class="w-6 h-6" />  -->
             Team <span class="text-amber-600 font-bold">{{ team.name }}</span> is raising funds for:
            </h5>
            <!-- TODO: Link to campaign -->
            <router-link class="hover:underline" :to="{name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug:fundraiser.slug }}">
              <h1 class="md:text-4xl xl:text-5xl">
                {{ fundraiser.title }}
              </h1>
            </router-link>
            <p class="md:text-lg leading-5" v-html="fundraiser.short_description" />
          </div>
        </div>
      </tw-container>
    </div>
    <tw-container class="relative max-w-[1360px]">
      <div class="grid lg:grid-cols-3 md:grid-cols-1">
        <fundraiser-team-right-column :fundraiser="fundraiser" :team="team" class="lg:col-span-1 lg:order-last relative mt-8 lg:mt-0 lg:-top-80" />
        <fundraiser-team-left-column :fundraiser="fundraiser" :team="team" class="lg:col-span-2 relative lg:static lg:pr-12" />
      </div>
    </tw-container>
  </div>
  <div v-else-if="Loading" class="flex items-center justify-center mt-6">
    <div class="flex items-center justify-center w-40 h-40 border border-gray-200 rounded-lg bg-gray-50 ">
      <div role="status">
        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="container mx-auto mt-4 p-4">
      <div class="text-center">
        <div class="text-2xl font-bold">
          This fundraiser team is not available
        </div>
        <div class="mt-4">
          <tw-button :to="{name: 'Home'}" size="lg">
            Go back to the home page
          </tw-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
